import { render, staticRenderFns } from "./ColumnConfigurator.vue?vue&type=template&id=09274770&scoped=true&"
import script from "./ColumnConfigurator.vue?vue&type=script&lang=js&"
export * from "./ColumnConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./ColumnConfigurator.vue?vue&type=style&index=0&id=09274770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09274770",
  null
  
)

export default component.exports